import styled from "styled-components";

const CreateRoomStyled = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export default CreateRoomStyled;
